import type {ExpressionV4} from 'services/metadata/types';

export const isExpressionValue = (value: unknown): value is ExpressionV4 =>
  typeof value === 'object' &&
  (value as ExpressionV4)?.expressionFormat !== undefined;
